"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { searchTableColumn } from "./SearchTableRows";
import { candidatePoolTableColumn } from "./CandidatePoolTableRows";
export const InitialSearchesState = {
  snackbar: {
    message: "",
    state: "success"
  },
  searchesTableState: {
    canScroll: [false, false],
    tableHovered: false,
    density: "Default",
    columns: searchTableColumn,
    selectedItemIds: [],
    selectedItems: [],
    modalsOpen: {},
    actions: {
      selectedItem: null,
      anchorEl: null,
      isOpen: {}
    }
  },
  searchesTableSettings: {
    page: 1,
    limit: 20,
    sort: "id",
    sort_order: "desc"
  },
  searchQuery: "",
  totalPages: 0,
  searchesCount: 0
};
export const InitialCandidatePoolsState = {
  snackbar: {
    message: "",
    state: "success"
  },
  candidatePoolsTableState: {
    canScroll: [false, false],
    tableHovered: false,
    density: "Default",
    columns: candidatePoolTableColumn,
    selectedItemIds: [],
    selectedItems: [],
    modalsOpen: {
      email: false
    },
    actions: {
      selectedItem: null,
      anchorEl: null,
      isOpen: {}
    }
  },
  candidatePoolsTableSettings: {
    page: 1,
    limit: 20,
    sort: "id",
    sort_order: "desc"
  },
  searchQuery: "",
  totalPages: 0,
  candidatePoolsCount: 0
};
export const SearchesReducer = (state, action) => {
  switch (action.type) {
    case "SET_SNACKBAR":
      return __spreadProps(__spreadValues({}, state), {
        snackbar: action.payload
      });
    case "SET_SEARCH_QUERY":
      return __spreadProps(__spreadValues({}, state), {
        searchQuery: action.payload,
        searchesTableSettings: __spreadProps(__spreadValues({}, state.searchesTableSettings), {
          page: 1
        })
      });
    case "CLEAR_SEARCH_QUERY":
      return __spreadProps(__spreadValues({}, state), {
        searchQuery: "",
        searchesTableSettings: __spreadProps(__spreadValues({}, state.searchesTableSettings), {
          page: 1
        })
      });
    case "SET_TOTAL_PAGES":
      return __spreadProps(__spreadValues({}, state), {
        totalPages: action.payload
      });
    case "SET_SEARCHES_COUNT":
      return __spreadProps(__spreadValues({}, state), {
        searchesCount: action.payload
      });
    case "SET_DENSITY":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          density: action.payload
        })
      });
    case "SET_DEFAULT_DATA":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadValues(__spreadValues({}, state.searchesTableState), action.payload)
      });
    case "SET_CAN_SCROLL":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          canScroll: action.payload
        })
      });
    case "SET_TABLE_HOVERED":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          tableHovered: action.payload
        })
      });
    case "ADD_SELECTED_ITEM":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          selectedItems: [...state.searchesTableState.selectedItems, action.payload],
          selectedItemIds: [...state.searchesTableState.selectedItemIds, action.payload.id]
        })
      });
    case "REMOVE_SELECTED_ITEM":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          selectedItems: state.searchesTableState.selectedItems.filter(
            (item) => item.id !== action.payload
          ),
          selectedItemIds: state.searchesTableState.selectedItemIds.filter(
            (id) => id !== action.payload
          )
        })
      });
    case "ADD_ALL_PAGE_ITEMS":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          selectedItems: [...state.searchesTableState.selectedItems, ...action.payload],
          selectedItemIds: [
            ...state.searchesTableState.selectedItemIds,
            ...action.payload.map((item) => item.id)
          ]
        })
      });
    case "REMOVE_ALL_SELECTED_ITEMS":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          selectedItems: [],
          selectedItemIds: []
        })
      });
    case "REMOVE_ALL_PAGE_ITEMS":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          selectedItems: state.searchesTableState.selectedItems.filter(
            (item) => !action.payload.includes(item.id)
          ),
          selectedItemIds: state.searchesTableState.selectedItemIds.filter(
            (id) => !action.payload.includes(id)
          )
        })
      });
    case "SELECT_ALL_ITEMS":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          selectedItemIds: action.payload
        })
      });
    case "SET_COLUMNS":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          columns: action.payload
        })
      });
    case "SET_PAGE":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableSettings: __spreadProps(__spreadValues({}, state.searchesTableSettings), {
          page: action.payload
        })
      });
    case "SET_LIMIT":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableSettings: __spreadProps(__spreadValues({}, state.searchesTableSettings), {
          limit: action.payload
        })
      });
    case "SET_SORT":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableSettings: __spreadProps(__spreadValues({}, state.searchesTableSettings), {
          sort: action.payload.sortBy,
          sort_order: action.payload.sortOrder
        })
      });
    case "SELECT_ACTION_ITEM":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          actions: __spreadProps(__spreadValues({}, state.searchesTableState.actions), {
            selectedItem: action.payload.item,
            anchorEl: action.payload.anchorEl,
            isOpen: __spreadProps(__spreadValues({}, state.searchesTableState.actions.isOpen), {
              [action.payload.name]: true
            })
          })
        })
      });
    case "CLOSE_ACTION_ITEM":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          actions: __spreadProps(__spreadValues({}, state.searchesTableState.actions), {
            isOpen: __spreadProps(__spreadValues({}, state.searchesTableState.actions.isOpen), {
              [action.payload]: false
            })
          })
        })
      });
    case "SET_ACTION_MODAL_OPEN":
      return __spreadProps(__spreadValues({}, state), {
        searchesTableState: __spreadProps(__spreadValues({}, state.searchesTableState), {
          modalsOpen: __spreadProps(__spreadValues({}, state.searchesTableState.modalsOpen), {
            [action.payload.name]: action.payload.isOpen
          })
        })
      });
    case "SET_SELECTED_ROW_DATA":
      return state;
    case "REMOVE_SELECTED_ROW_DATA":
      return state;
    default:
      return state;
  }
};
export const CandidatePoolsReducer = (state, action) => {
  switch (action.type) {
    case "SET_SNACKBAR":
      return __spreadProps(__spreadValues({}, state), {
        snackbar: action.payload
      });
    case "SET_SEARCH_QUERY":
      return __spreadProps(__spreadValues({}, state), {
        searchQuery: action.payload,
        candidatePoolsTableSettings: __spreadProps(__spreadValues({}, state.candidatePoolsTableSettings), {
          page: 1
        })
      });
    case "CLEAR_SEARCH_QUERY":
      return __spreadProps(__spreadValues({}, state), {
        searchQuery: "",
        candidatePoolsTableSettings: __spreadProps(__spreadValues({}, state.candidatePoolsTableSettings), {
          page: 1
        })
      });
    case "SET_TOTAL_PAGES":
      return __spreadProps(__spreadValues({}, state), {
        totalPages: action.payload
      });
    case "SET_CANDIDATE_POOLS_COUNT":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsCount: action.payload
      });
    case "SET_DENSITY":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          density: action.payload
        })
      });
    case "SET_DEFAULT_DATA":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadValues(__spreadValues({}, state.candidatePoolsTableState), action.payload)
      });
    case "SET_CAN_SCROLL":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          canScroll: action.payload
        })
      });
    case "SET_TABLE_HOVERED":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          tableHovered: action.payload
        })
      });
    case "ADD_SELECTED_ITEM":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          selectedItems: [...state.candidatePoolsTableState.selectedItems, action.payload],
          selectedItemIds: [...state.candidatePoolsTableState.selectedItemIds, action.payload.id]
        })
      });
    case "REMOVE_SELECTED_ITEM":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          selectedItems: state.candidatePoolsTableState.selectedItems.filter(
            (item) => item.id !== action.payload
          ),
          selectedItemIds: state.candidatePoolsTableState.selectedItemIds.filter(
            (id) => id !== action.payload
          )
        })
      });
    case "ADD_ALL_PAGE_ITEMS":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          selectedItems: [...state.candidatePoolsTableState.selectedItems, ...action.payload],
          selectedItemIds: [
            ...state.candidatePoolsTableState.selectedItemIds,
            ...action.payload.map((item) => item.id)
          ]
        })
      });
    case "REMOVE_ALL_SELECTED_ITEMS":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          selectedItems: [],
          selectedItemIds: []
        })
      });
    case "REMOVE_ALL_PAGE_ITEMS":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          selectedItems: state.candidatePoolsTableState.selectedItems.filter(
            (item) => !action.payload.includes(item.id)
          ),
          selectedItemIds: state.candidatePoolsTableState.selectedItemIds.filter(
            (id) => !action.payload.includes(id)
          )
        })
      });
    case "SELECT_ALL_ITEMS":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          selectedItemIds: action.payload
        })
      });
    case "SET_COLUMNS":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          columns: action.payload
        })
      });
    case "SET_PAGE":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableSettings: __spreadProps(__spreadValues({}, state.candidatePoolsTableSettings), {
          page: action.payload
        })
      });
    case "SET_LIMIT":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableSettings: __spreadProps(__spreadValues({}, state.candidatePoolsTableSettings), {
          limit: action.payload
        })
      });
    case "SET_SORT":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableSettings: __spreadProps(__spreadValues({}, state.candidatePoolsTableSettings), {
          sort: action.payload.sortBy,
          sort_order: action.payload.sortOrder
        })
      });
    case "SELECT_ACTION_ITEM":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          actions: __spreadProps(__spreadValues({}, state.candidatePoolsTableState.actions), {
            selectedItem: action.payload.item,
            anchorEl: action.payload.anchorEl,
            isOpen: __spreadProps(__spreadValues({}, state.candidatePoolsTableState.actions.isOpen), {
              [action.payload.name]: true
            })
          })
        })
      });
    case "CLOSE_ACTION_ITEM":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          actions: __spreadProps(__spreadValues({}, state.candidatePoolsTableState.actions), {
            isOpen: __spreadProps(__spreadValues({}, state.candidatePoolsTableState.actions.isOpen), {
              [action.payload]: false
            })
          })
        })
      });
    case "SET_ACTION_MODAL_OPEN":
      return __spreadProps(__spreadValues({}, state), {
        candidatePoolsTableState: __spreadProps(__spreadValues({}, state.candidatePoolsTableState), {
          modalsOpen: __spreadProps(__spreadValues({}, state.candidatePoolsTableState.modalsOpen), {
            [action.payload.name]: action.payload.isOpen
          })
        })
      });
    case "SET_SELECTED_ROW_DATA":
      return state;
    case "REMOVE_SELECTED_ROW_DATA":
      return state;
    default:
      return state;
  }
};
